import { Reducer } from 'redux';
import { IPersistedCatalogueFilters } from '../../types';

const initialState: IPersistedCatalogueFilters = {
  checkedCategory: -1,
  checkedSubCategories: [],
  checkedTradingGroups: [],
  caseSize: '',
  orderBy: 2,
  displayMode: 'list',
  useCurrentShoppingList: false,
  tradingPromotionChecked: false,
  tradingPackChecked: false,
  tradingPackCheckedCategories: [],
  tradingPackCheckedLocations: [],
};

const persistCatalogueFiltersReducer: Reducer<IPersistedCatalogueFilters> =
(state: IPersistedCatalogueFilters = initialState, action: any): IPersistedCatalogueFilters => {
  if (action.type === 'CATALOGUE_FILTERS_PERSIST') {
    return {
      ...action.payload,
    };
  }
  if (action.type === 'CATALOGUE_FILTERS_CLEAR') {
    return initialState;
  }
  return state;
};

export default persistCatalogueFiltersReducer;
